export default "/static/assets/account-white.01a764cb910ad9edc8be76499e5df69b.svg";